import { useState } from 'react'

const animationSpeed = 250

export const useAccordion = (allowCollapsingAll: boolean = false, openWithAllClosed: boolean = false) => {
  const [expanded, setExpanded] = useState<number | undefined>(openWithAllClosed ? undefined : 0)

  const [animationActive, setAnimationActive] = useState<ReturnType<typeof setTimeout> | undefined>(undefined)
  const handleHeaderClick = (i: number) => () => {
    let didChange = false
    if (expanded === i && allowCollapsingAll) {
      setExpanded(undefined)
      didChange = true
    } else {
      setExpanded(i)
      didChange = true
    }
    if (didChange) {
      if (animationActive) {
        clearTimeout(animationActive)
      }
      const timeout = setTimeout(() => {
        setAnimationActive(undefined)
      }, animationSpeed)
      setAnimationActive(timeout)
    }
  }

  return {
    expanded,
    setExpanded,
    handleHeaderClick,
    animationActive,
  }
}
